<template>

  <div style="width:100%;height: 100%;overflow: auto">
    <div style="margin-top: 10px;margin-left: 10px;font-size: 18px;"><b>结单率：</b></div>
    <div style="width:calc(100% - 20px);display: flex;flex-wrap: wrap;height: auto;margin: 10px 0 0 10px;border: 1px solid #ececec; " >
      <div style="width: 400px;height: 300px;" v-for="(item,index) in legalList" :id="'legalChart-' + index"></div>
    </div>

    <div style="margin-top: 10px;margin-left: 10px;font-size: 18px;"><b>U-Leads：</b></div>
    <div style="display: flex;flex-wrap: wrap;height: auto;margin-top: 10px; ">
      <div style="width: 400px;height: 300px;" id="uOneAndManyChart"></div>
    </div>

    <div style="margin-top: 10px;margin-left: 10px;font-size: 18px;"><b>员工U-Leads成单率：</b></div>
    <div style="width: 98%;height: 300px;" id="uLeadsSuccessOrder"></div>

    <div style="margin-top: 10px;margin-left: 10px;font-size: 18px;"><b>T-Leads：</b></div>
    <div style="display: flex;flex-wrap: wrap;height: auto;margin-top: 10px; ">
      <div style="width: 400px;height: 300px;" id="tOneAndManyChart"></div>
    </div>

    <div style="margin-top: 10px;margin-left: 10px;font-size: 18px;"><b>员工T-Leads成单率：</b></div>
    <div style="width: 98%;height: 300px;" id="tLeadsSuccessOrder"></div>




  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "LegalData",

  data(){
    return {
      legalSeriesData:{},
      oneAndManySeriesData:[],
      uLeadsSuccessSeriesData:[],
      uLeadsSuccessXLengthData:[],
      tOneAndManySeriesData:[],
      tLeadsSuccessSeriesData:[],
      tLeadsSuccessXLengthData:[],

    }
  },
  async created(){
    await this.initLegalData();
    await this.getAllData();
    await this.renderAllEcharts();

  },
  computed: {
    legalList() {
      return this.$store.getters['core/getDictList']('legal_type');
    },
  },
  methods:{

    async initLegalData(){
      await this.getLegalData();
      for (let item of this.legalList){
        let index = this.legalList.indexOf(item);
        let name = item.name;
        await this.renderEcharts(this.legalSeriesData[item.value],name,index);
      }
    },
    async getLegalData(){
      this.legalSeriesData = await this.$http('crmBusinessService.getLegalData');
    },
    async getAllData(){
      this.oneAndManySeriesData = await this.$http('crmBusinessService.getOneAndManyData');
      let data = await this.$http('crmBusinessService.getULeadsSuccessOrder');
      this.uLeadsSuccessSeriesData = data?.seriesData;
      this.uLeadsSuccessXLengthData = data?.xLengthData;
      this.tOneAndManySeriesData = await this.$http('crmBusinessService.getTOneAndManyData');
      let TData = await this.$http('crmBusinessService.getTLeadsSuccessOrder');
      this.tLeadsSuccessSeriesData = TData?.seriesData;
      this.tLeadsSuccessXLengthData = TData?.xLengthData;

    },


    renderEcharts(data,name,index){
      const uLeadsChartDom = document.getElementById('legalChart-' + index);
      // 获取现有的 ECharts 实例（如果有）
      let uLeadsChart = echarts.getInstanceByDom(uLeadsChartDom);
      // 如果存在现有的实例，销毁它
      if (uLeadsChart) {
        uLeadsChart.dispose();
      }
      // 初始化新的 ECharts 实例
      uLeadsChart = echarts.init(uLeadsChartDom);
      uLeadsChart.setOption(this.getULeadsChartOptions(data,name), true);
    },
    getULeadsChartOptions(data,name){
      const total = data.reduce((sum, item) => sum + item.value, 0);
      return{
        title: {
          text: name + '：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '机会数\n' + total,
            textAlign: 'center',
            fontSize: 20,
            fill: '#0074e0',
          },
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / total) * 100).toFixed(2);
            if(total === 0.0 || total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            data: data === undefined ? [] : data,
          }
        ]
      }
    },
    renderAllEcharts(){
      const uOneAndManyChartDom = document.getElementById('uOneAndManyChart');
      const uLeadsSuccessChartDom = document.getElementById('uLeadsSuccessOrder');
      const tOneAndManyChartDom = document.getElementById('tOneAndManyChart');
      const tLeadsSuccessChartDom = document.getElementById('tLeadsSuccessOrder');
      // 获取现有的 ECharts 实例（如果有）
      let uOneAndManyChart = echarts.getInstanceByDom(uOneAndManyChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let uLeadsSuccessChart = echarts.getInstanceByDom(uLeadsSuccessChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let tOneAndManyChart = echarts.getInstanceByDom(tOneAndManyChartDom);
      // 获取现有的 ECharts 实例（如果有）
      let tLeadsSuccessChart = echarts.getInstanceByDom(tLeadsSuccessChartDom);
      // 如果存在现有的实例，销毁它
      if (uOneAndManyChart) {
        uOneAndManyChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (uLeadsSuccessChart) {
        uLeadsSuccessChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (tOneAndManyChart) {
        tOneAndManyChart.dispose();
      }
      // 如果存在现有的实例，销毁它
      if (tLeadsSuccessChart) {
        tLeadsSuccessChart.dispose();
      }
      // 初始化新的 ECharts 实例
      uOneAndManyChart = echarts.init(uOneAndManyChartDom);
      uOneAndManyChart.setOption(this.getUOneAndManyChartOptions(), true);
      // 初始化新的 ECharts 实例
      uLeadsSuccessChart = echarts.init(uLeadsSuccessChartDom);
      uLeadsSuccessChart.setOption(this.getULeadsSuccessChartOptions(), true);
      // 初始化新的 ECharts 实例
      tOneAndManyChart = echarts.init(tOneAndManyChartDom);
      tOneAndManyChart.setOption(this.getTOneAndManyChartOptions(), true);
      // 初始化新的 ECharts 实例
      tLeadsSuccessChart = echarts.init(tLeadsSuccessChartDom);
      tLeadsSuccessChart.setOption(this.getTLeadsSuccessChartOptions(), true);
    },
    getUOneAndManyChartOptions(){
      const total = this.oneAndManySeriesData.reduce((sum, item) => sum + item.value, 0);
      return{
        title: {
          text: '1拖N占比：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '成单\n' + total,
            textAlign: 'center',
            fontSize: 20,
            fill: '#0074e0',
          },
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / total) * 100).toFixed(2);
            if(total === 0.0 || total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            data: this.oneAndManySeriesData === undefined ? [] : this.oneAndManySeriesData,
          }
        ]
      }
    },
    getULeadsSuccessChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.uLeadsSuccessXLengthData === undefined ? [] : this.uLeadsSuccessXLengthData,
          }
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks:true
          },
          {
            type: 'value',
            name: '比例',
            max:100,
            min:0,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.uLeadsSuccessSeriesData === undefined ? [] : this.uLeadsSuccessSeriesData,
      }
    },
    getTOneAndManyChartOptions(){
      return{
        title: {
          text: '1拖N占比：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            data: this.tOneAndManySeriesData === undefined ? [] : this.tOneAndManySeriesData,
          }
        ]
      }
    },
    getTLeadsSuccessChartOptions(){
      return{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.tLeadsSuccessXLengthData === undefined ? [] : this.tLeadsSuccessXLengthData,
          }
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks:true,
          },
          {
            type: 'value',
            name: '比例',
            max:100,
            min:0,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.tLeadsSuccessSeriesData === undefined ? [] : this.tLeadsSuccessSeriesData,
      }
    },


  }
}
</script>

<style scoped>

</style>